import uuidv4 from 'uuid/v4';

import { ISanityVendorConfigs } from '@rbi-ctg/menu';

import { MIN_IN_RESTAURANT_CART_QUANTITY } from './constants';
import {
  IInRestaurantRedemptionCartEntry,
  IInRestaurantRedemptionEntryType,
  IOfferRedemption,
  IRewardRedemption,
  InRestaurantRedemptionObject,
  isRedemptionObjectLegacyOffer,
  isRedemptionObjectOffer,
  isRedemptionObjectReward,
} from './types';

const generateReferenceId = (): string => uuidv4();

const createInRestaurantRedemptionEntryFromReward = ({
  reward,
  engineReward,
}: IRewardRedemption): IInRestaurantRedemptionCartEntry => ({
  incentiveId: engineReward.id,
  vendorConfigs: reward.vendorConfigs as ISanityVendorConfigs,
  type: IInRestaurantRedemptionEntryType.REWARD,
  details: { reward, engineReward },
  referenceId: generateReferenceId(),
  quantity: MIN_IN_RESTAURANT_CART_QUANTITY,
});

const createInRestaurantRedemptionEntryFromOffer = ({
  offer,
}: IOfferRedemption): IInRestaurantRedemptionCartEntry => ({
  incentiveId: offer._id,
  vendorConfigs: offer.vendorConfigs as ISanityVendorConfigs,
  type: IInRestaurantRedemptionEntryType.OFFER,
  details: { offer },
  referenceId: generateReferenceId(),
  quantity: MIN_IN_RESTAURANT_CART_QUANTITY,
});

const createInRestaurantRedemptionEntryFromLegacyOffer = (
  offer: IOfferRedemption
): IInRestaurantRedemptionCartEntry => ({
  ...createInRestaurantRedemptionEntryFromOffer(offer),
  type: IInRestaurantRedemptionEntryType.LEGACY_OFFER,
});

export const createInRestaurantRedemptionCartEntry = (
  redemptionObject: InRestaurantRedemptionObject
): IInRestaurantRedemptionCartEntry | null => {
  let returnObject: IInRestaurantRedemptionCartEntry | null = null;

  if (isRedemptionObjectOffer(redemptionObject)) {
    returnObject = createInRestaurantRedemptionEntryFromOffer(redemptionObject);
  } else if (isRedemptionObjectReward(redemptionObject)) {
    returnObject = createInRestaurantRedemptionEntryFromReward(redemptionObject);
  } else if (isRedemptionObjectLegacyOffer(redemptionObject)) {
    returnObject = createInRestaurantRedemptionEntryFromLegacyOffer(redemptionObject);
  }

  return returnObject;
};
